import { render, staticRenderFns } from "./FiltersForTable.vue?vue&type=template&id=6b1b108a&"
import script from "./FiltersForTable.vue?vue&type=script&lang=ts&"
export * from "./FiltersForTable.vue?vue&type=script&lang=ts&"
import style0 from "./FiltersForTable.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports